module.exports = __webpack_public_path__ + "img/farzana-christopher-31.8ae0396c.jpg";